import React from "react";
import ct from "class-types.macro";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import PlusPriceContainer from "../PlusPriceContainer";
import PlusPriceBox from "../PlusPriceBox";
import DivideByPricing from "../DivideByPricing";

interface Props {
  p1Price: number;
  mapPrice: number;
  unitOfMeasure: string;
  hasQuantityDiscounts: boolean;
  productListingView?: string;
  divideByUnit?: string;
  divideQuantity?: number;
}

const ExclusivePlusPricing = ({
  mapPrice,
  p1Price,
  unitOfMeasure,
  hasQuantityDiscounts,
  productListingView,
  divideByUnit,
  divideQuantity,
}: Props) => {
  return (
    <PlusPriceContainer productListingView={productListingView}>
      <PlusPriceBox>
        <p
          className={ct(
            "block",
            "font-semibold",
            "text-xs",
            "leading-none",
            "mb-0",
            "p-0",
            "text-blue-800",
          )}
        >
          Plus Member Price
        </p>
        <p
          data-testid="price"
          className={ct(
            "block",
            "font-semibold",
            "leading-none",
            "mb-0",
            "p-0",
            "relative",
            "text-center",
            "text-blue-800",
            productListingView === "list" ? ct("text-xl") : ct("text-2xl"),
          )}
        >
          {formatAsCurrency.formatIfUndefined(mapPrice)}
          <span className={ct("text-2xs", "leading-none", "text-blue-800")}>
            /{unitOfMeasure}
          </span>
        </p>
        <DivideByPricing
          dataTestId="divideByPricing"
          price={mapPrice}
          divideByUnit={divideByUnit}
          divideQuantity={divideQuantity}
        />
      </PlusPriceBox>
      {!hasQuantityDiscounts && (
        <p
          className={ct(
            "font-semibold",
            "text-xs",
            "leading-none",
            "m-0",
            "mt-1",
            productListingView === "list"
              ? ct("xs:text-center")
              : ct("text-center"),
          )}
        >
          Retail Price{" "}
          <span
            className={ct(
              "font-semibold",
              "text-xs",
              "leading-none",
              "mb-0",
              "text-center",
              "text-red-500",
              "line-through",
            )}
          >
            {formatAsCurrency.formatIfUndefined(p1Price)}
          </span>
        </p>
      )}
    </PlusPriceContainer>
  );
};

export default ExclusivePlusPricing;
